
  import { SmartBannerConfig } from './index'
  export const config: SmartBannerConfig = {
    festivalName: 'BABEL MUSIC XP',
    appTitle: 'BABEL MUSIC XP',
    appStoreId: '0',
    appleStoreUrl: 'https://apps.apple.com/fr/app/babel-music-xp/id828427676',
    googleStoreUrl: 'https://play.google.com/store/apps/details?id=to.chapi.babelmusicxp&gl=FR',
    appIconUrl: 'https://static.babelmusicxp.chapi.to/app-icon.jpeg',
  }
